export default "__VITE_ASSET__E9sSWyvK__"